import Roles from './Roles';
import TxStatus from './TxStatuses';
import ValUtils from './ValUtils';

/**
 * parseGroupPath("/10001/admin") => { partnerId: 10001, role: "admin" }
 */
function parseGroupPath(fullGroupPath) {
  if (!fullGroupPath.startsWith("/")) return null;
  const withoutSlash = fullGroupPath.substring(1); // e.g. "10001/admin"
  const parts = withoutSlash.split("/");
  if (parts.length < 2) return null;

  const partnerIdStr = parts[0];
  const role = parts[1];
  const partnerId = parseInt(partnerIdStr, 10);
  if (isNaN(partnerId)) return null;

  return { partnerId, role };
}

var User = (function () {
  let userId = 0;
  let userKey = "";
  let phone = "";
  let email = "";
  let status = 8; // WAITING
  let sessionId = "";
  let activePartner = 0;
  let groups = [];

  const device = ValUtils.getBrowser() + " (" + ValUtils.getOS() + ")";
  const host = window.location.hostname;

  // Basic getters/setters
  var getUserId = function () { return userId; };
  var setUserId = function (id) { userId = id; };

  var getActivePartner = function () { return activePartner; };
  var setActivePartner = function (pid) { activePartner = pid; };

  var getPhone = function () { return phone; };
  var setPhone = function (number) { phone = number; };

  var getEmail = function () { return email; };
  var setEmail = function (emailAddr) { email = emailAddr; };

  var getStatus = function () { return status; };
  var setStatus = function (st) { status = parseInt(st); };

  var getUserKey = function () { return userKey; };
  var setUserKey = function (key) { userKey = key; };

  var getSessionId = function () { return sessionId; };
  var setSessionId = function (sid) { sessionId = sid; };

  var isReady = function () {
    return status === TxStatus.SUCCESS;
  };

  // phone format
  var getDisplayPhone = function () {
    if (phone.startsWith("84")) {
      return "0" + phone.substring(2);
    }
    return phone;
  };
  var getFormatedPhone = function () {
    if (phone.startsWith("0")) {
      return "84" + phone.substring(1);
    }
    return phone;
  };

  // Identity
  var getIdentity = function () {
    return {
      src: "web",
      node: host,
      version: "2.0",
      device: device,
      userId: userId,
      email: email,
      phone: phone,
      statusId: status
    };
  };

  var clearIdentity = function () {
    userId = 0;
    userKey = "";
    status = 8;
    sessionId = "";
  };

  // setGroups
  const setGroups = (keycloakGroups) => {
    groups = Array.isArray(keycloakGroups) ? keycloakGroups : [];
  };

  // getActiveRole: loop all groups, find group w/ partnerId=activePartner => return role
  const getActiveRole = () => {
    if (!activePartner || groups.length === 0) return Roles.NONE;

    for (const g of groups) {
      const parsed = parseGroupPath(g);
      if (parsed && parsed.partnerId === activePartner) {
        switch (parsed.role.toLowerCase()) {
          case Roles.ADMIN:
            return Roles.ADMIN;
          case Roles.MANAGER:
            return Roles.MANAGER;
          case Roles.STAFF:
            return Roles.STAFF;
          case Roles.OWNER:
            // If your logic: once found owner => do something? 
            // Or keep searching in case multiple roles
            return Roles.OWNER;
          default:
            return Roles.NONE;
        }
      }
    }
    return Roles.NONE;
  };

  // isOwner
  const isOwner = () => {
    if (!activePartner || groups.length === 0) return false;
    for (const g of groups) {
      const parsed = parseGroupPath(g);
      if (parsed && parsed.partnerId === activePartner && parsed.role.toLowerCase() === Roles.OWNER) {
        return true;
      }
    }
    return false;
  };

  const hasActivePartner = () => {
    return getActiveRole() !== Roles.NONE;
  };

  // Return
  return {
    getUserId,
    setUserId,
    getPhone,
    setPhone,
    getDisplayPhone,
    getFormatedPhone,
    getEmail,
    setEmail,
    getStatus,
    setStatus,
    getUserKey,
    setUserKey,
    getSessionId,
    setSessionId,
    isReady,
    getActivePartner,
    setActivePartner,
    hasActivePartner,
    getActiveRole,
    isOwner,
    getIdentity,
    clearIdentity,
    setGroups
  };
})();

export default User;
